import Vue from 'vue'
import VueRouter from 'vue-router'

// 登录模块引入
// 1. 定义 (路由) 组件。
// 可以从其他文件 import 进来
// eslint-disable-next-line quotes
import home from "./home/home"
import order from './order/order'
import verify from './verify/verify'
Vue.use(VueRouter)

// 2. 定义路由
// 每个路由应该映射一个组件。 其中"component" 可以是
// 通过 Vue.extend() 创建的组件构造器，
// 或者，只是一个组件配置对象。

let allRouter = home.concat(
  home,
  order,
  verify
)

// 3. 并创建 router 实例，然后传 `routes` 配置
const router = new VueRouter({
  // 去掉url中的# 采用history模式
  mode: 'history',
  base: 'ticketpf',
  'routes': allRouter
})
export default router



// WEBPACK FOOTER //
// ./src/router/index.js